import { render, staticRenderFns } from "./ProductionPod.vue?vue&type=template&id=496c805b&"
import script from "./ProductionPod.vue?vue&type=script&lang=js&"
export * from "./ProductionPod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports